

// import React, { useState, useEffect } from "react";
// import { FaPlus, FaEdit } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import CreateClassModal from "./CreateClassModal";
// import axios from "axios";

// const Classes = ({ admin }) => {
//   const navigate = useNavigate();

//   const [showClassModal, setShowClassModal] = useState(false);
//   const [selectedClass, setSelectedClass] = useState(null); // For edit
//   const [classes, setClasses] = useState([]);

//   // Fetch all classes
//   const fetchClasses = async () => {
//     try {
//       const res = await axios.get("https://api.scannscore.com/class");
//       if (res.status === 200) {
//         setClasses(res.data);
//       }
//     } catch (err) {
//       console.error("Error fetching classes:", err);
//     }
//   };

//   useEffect(() => {
//     fetchClasses();
//   }, []);


//   const handleCardClick = (cls) => {
//     navigate("/admin/student", { state: { classData: cls } });
//   };

  
//   const handleEditClick = (cls, e) => {
//     e.stopPropagation(); 
//     setSelectedClass(cls);
//     setShowClassModal(true);
//   };

//   return (
//     <div
//       className="p-3 p-md-4 w-100"
//       style={{ minHeight: "100vh", background: "#f4f6ff" }}
//     >
//       {/* Header */}
//       <div className="d-flex justify-content-between align-items-center mb-4 w-100">
//         <h2 className="fw-bold mb-0">Classes</h2>
//         {(admin.role === "admin" || admin.class === 1) && (
//           <button
//             className="btn btn-primary d-flex align-items-center"
//             onClick={() => {
//               setSelectedClass(null); // New class
//               setShowClassModal(true);
//             }}
//           >
//             <FaPlus className="me-2" />
//             New Class
//           </button>
//         )}
//       </div>

//       {/* Classes Grid */}
//       <div className="row g-3">
//         {classes.length === 0 ? (
//           <p className="text-center text-muted mt-5 w-100">
//             No classes available
//           </p>
//         ) : (
//           classes.map((cls, idx) => (
//             <div key={cls.id || idx} className="col-12 col-sm-6 col-md-4 col-lg-3">
//               <div
//                 className="card shadow-sm h-100 position-relative"
//                 style={{
//                   borderRadius: "12px",
//                   borderLeft: "6px solid #2F49CF",
//                   cursor: "pointer",
//                   overflow: "hidden", // keeps edit button inside card
//                 }}
//                 onClick={() => handleCardClick(cls)}
//               >
//                 {/* Edit Button */}
//                 {(admin.role === "admin" || admin.class === 1) && (
//                   <button
//                     onClick={(e) => handleEditClick(cls, e)}
//                     style={{
//                       position: "absolute",
//                       top: "8px",
//                       right: "8px",
//                       border: "none",
//                       background: "rgba(255,255,255,0.9)",
//                       borderRadius: "50%",
//                       width: "30px",
//                       height: "30px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       cursor: "pointer",
//                       boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
//                       transition: "all 0.2s",
//                     }}
//                     title="Edit Class"
//                     onMouseOver={(e) => (e.currentTarget.style.background = "white")}
//                     onMouseOut={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.9)")}
//                   >
//                     <FaEdit size={14} color="#2F49CF" />
//                   </button>
//                 )}

//                 <div className="card-body">
//                   <h5 className="card-title fw-bold" style={{ color: "#2F49CF" }}>
//                     {cls.class_name}
//                   </h5>

//                   <p className="fw-semibold mb-2">Section: {cls.section}</p>

//                   <p className="text-muted small mb-0">
//                     {cls.description || "No description provided"}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       {/* Create / Edit Modal */}
//       {showClassModal && (
//         <CreateClassModal
//           show={showClassModal}
//           admin={admin}
//           classData={selectedClass} // null for new, object for edit
//           closeModal={() => {
//             setShowClassModal(false);
//             setSelectedClass(null);
//             fetchClasses(); // refresh list
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default Classes;





// import React, { useState, useEffect } from "react";
// import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import CreateClassModal from "./CreateClassModal";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";

// const MySwal = withReactContent(Swal);

// const Classes = ({ admin }) => {
//   const navigate = useNavigate();

//   const [showClassModal, setShowClassModal] = useState(false);
//   const [selectedClass, setSelectedClass] = useState(null);
//   const [classes, setClasses] = useState([]);

//   const fetchClasses = async () => {
//     try {
//       const res = await axios.get("https://api.scannscore.com/class");
//       if (res.status === 200) {
//         setClasses(res.data);
//       }
//     } catch (err) {
//       console.error("Error fetching classes:", err);
//       toast.error("Failed to load classes ");
//     }
//   };

//   useEffect(() => {
//     fetchClasses();
//   }, []);

//   const handleCardClick = (cls) => {
//     navigate("/admin/student", { state: { classData: cls } });
//   };

//   const handleEditClick = (cls, e) => {
//     e.stopPropagation();
//     setSelectedClass(cls);
//     setShowClassModal(true);
//   };

  
//   const handleDeleteClick = async (cls, e) => {
//     e.stopPropagation();

//     const result = await MySwal.fire({
//       title: "Are you sure?",
//       text: "You want to delete this class!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonText: "Cancel",
//     });

//     if (result.isConfirmed) {
//       try {
//         await axios.delete(`https://api.scannscore.com/delete-class/${cls.id}`);
//         toast.success("Class deleted successfully ");
//         fetchClasses();
//       } catch (err) {
//         toast.error(err.response?.data?.message || "Delete failed ");
//       }
//     }
//   };

//   return (
//     <div
//       className="p-3 p-md-4 w-100"
//       style={{ minHeight: "100vh", background: "#f4f6ff" }}
//     >
  
//       <div className="d-flex justify-content-between align-items-center mb-4 w-100">
//         <h2 className="fw-bold mb-0">Classes</h2>

//         {(admin.role === "admin" || admin.class === 1) && (
//           <button
//             className="btn btn-primary d-flex align-items-center"
//             onClick={() => {
//               setSelectedClass(null);
//               setShowClassModal(true);
//             }}
//           >
//             <FaPlus className="me-2" />
//             New Class
//           </button>
//         )}
//       </div>

      
//       <div className="row g-3">
//         {classes.length === 0 ? (
//           <p className="text-center text-muted mt-5 w-100">
//             No classes available
//           </p>
//         ) : (
//           classes.map((cls, idx) => (
//             <div key={cls.id || idx} className="col-12 col-sm-6 col-md-4 col-lg-3">
//               <div
//                 className="card shadow-sm h-100 position-relative"
//                 style={{
//                   borderRadius: "12px",
//                   borderLeft: "6px solid #2F49CF",
//                   cursor: "pointer",
//                   overflow: "hidden",
//                 }}
//                 onClick={() => handleCardClick(cls)}
//               >
                
//                 {(admin.role === "admin" || admin.class === 1) && (
//                   <button
//                     onClick={(e) => handleEditClick(cls, e)}
//                     style={{
//                       position: "absolute",
//                       top: "8px",
//                       right: "45px",
//                       border: "none",
//                       background: "rgba(255,255,255,0.9)",
//                       borderRadius: "50%",
//                       width: "30px",
//                       height: "30px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <FaEdit size={14} color="#2F49CF" />
//                   </button>
//                 )}

            
//                 {(admin.role === "admin" || admin.class === 1) && (
//                   <button
//                     onClick={(e) => handleDeleteClick(cls, e)}
//                     style={{
//                       position: "absolute",
//                       top: "8px",
//                       right: "8px",
//                       border: "none",
//                       background: "rgba(255,255,255,0.9)",
//                       borderRadius: "50%",
//                       width: "30px",
//                       height: "30px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <FaTrash size={14} color="red" />
//                   </button>
//                 )}

//             <div className="card-body d-flex flex-column">
//   <h5
//     className="card-title fw-bold text-truncate"
//     style={{ color: "#2F49CF" }}
//     title={cls.class_name}
//   >
//     {cls.class_name}
//   </h5>

//   <p className="fw-semibold mb-2 text-truncate" title={cls.section}>
//     Section: {cls.section}
//   </p>

//   <p
//     className="text-muted small mb-0"
//     style={{
//       display: "-webkit-box",
//       WebkitLineClamp: 3, 
//       WebkitBoxOrient: "vertical",
//       overflow: "hidden",
//       textOverflow: "ellipsis",
//     }}
//     title={cls.description}
//   >
//     {cls.description || "No description provided"}
//   </p>
// </div>
//               </div>
//             </div>
//           ))
//         )}
//       </div>

     
//       {showClassModal && (
//         <CreateClassModal
//           show={showClassModal}
//           admin={admin}
//           classData={selectedClass}
//           closeModal={() => {
//             setShowClassModal(false);
//             setSelectedClass(null);
//             fetchClasses();
//           }}
//         />
//       )}

     
//       <ToastContainer
//         position="top-center"
//         autoClose={2000}
//         hideProgressBar={false}
//         newestOnTop
//         closeOnClick
//         pauseOnHover
//         theme="colored"
//       />
//     </div>
//   );
// };

// export default Classes;



import React, { useState, useEffect } from "react";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CreateClassModal from "./CreateClassModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const Classes = ({ admin }) => {

  const navigate = useNavigate();

  const [showClassModal, setShowClassModal] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const [classes, setClasses] = useState([]);

  const fetchClasses = async () => {
    try {
      const res = await axios.get("https://api.scannscore.com/class");
      if (res.status === 200) {
        setClasses(res.data);
      }
    } catch (err) {
      console.error("Error fetching classes:", err);
      toast.error("Failed to load classes");
    }
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  const handleCardClick = (cls) => {
    navigate("/admin/student", { state: { classData: cls } });
  };

  const handleEditClick = (cls, e) => {
    e.stopPropagation();
    setSelectedClass(cls);
    setShowClassModal(true);
  };

  const handleDeleteClick = async (cls, e) => {
    e.stopPropagation();

    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "You want to delete this class!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`https://api.scannscore.com/delete-class/${cls.id}`);
        toast.success("Class deleted successfully");
        fetchClasses();
      } catch (err) {
        toast.error(err.response?.data?.message || "Delete failed");
      }
    }
  };

  return (
    <div
      className="p-3 p-md-4 w-100"
      style={{ minHeight: "100vh", background: "#f4f6ff" }}
    >
   
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold mb-0">Classes</h2>

        {(admin.role === "admin" || admin.class === 1 || admin.role =='teacher' || admin.class_per == 1) && (
          <button
            className="btn btn-primary d-flex align-items-center"
            onClick={() => {
              setSelectedClass(null);
              setShowClassModal(true);
            }}
          >
            <FaPlus className="me-2" />
            New Class
          </button>
        )}
      </div>

     
      <div className="row g-3">
        {classes.length === 0 ? (
          <p className="text-center text-muted mt-5 w-100">
            No classes available
          </p>
        ) : (
          classes.map((cls, idx) => (
            <div
              key={cls.id || idx}
              className="col-12 col-sm-6 col-md-4 col-lg-3"
            >
              <div
                className="card shadow-sm h-100"
                style={{
                  borderRadius: "12px",
                  borderLeft: "6px solid #2F49CF",
                  cursor: "pointer",
                  transition: "0.2s",
                }}
                onClick={() => handleCardClick(cls)}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "translateY(-3px)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
              
                {(admin.role === "admin" || admin.class === 1 || admin.role =='teacher' || admin.class_per == 1 ) && (
                  <div className="d-flex justify-content-end gap-2 p-2">
                    <button
                      onClick={(e) => handleEditClick(cls, e)}
                      className="btn btn-light btn-sm"
                    >
                      <FaEdit size={14} color="#2F49CF" />
                    </button>

                    {/* <button
                      onClick={(e) => handleDeleteClick(cls, e)}
                      className="btn btn-light btn-sm"
                    >
                      <FaTrash size={14} color="red" />
                    </button> */}
                  </div>
                )}

                   {(admin.role === "admin" || admin.class === 1  ) && (
                  <div className="d-flex justify-content-end gap-2 p-2">
                  

                    <button
                      onClick={(e) => handleDeleteClick(cls, e)}
                      className="btn btn-light btn-sm"
                    >
                      <FaTrash size={14} color="red" />
                    </button>
                  </div>
                )}

              
                <div className="card-body d-flex flex-column">
                  <h5
                    className="card-title fw-bold text-truncate"
                    style={{ color: "#2F49CF" }}
                    title={cls.class_name}
                  >
                    {cls.class_name}
                  </h5>

                  <p
                    className="fw-semibold mb-2 text-truncate"
                    title={cls.section}
                  >
                    Section: {cls.section}
                  </p>

                  <p
                    className="text-muted small mb-0"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={cls.description}
                  >
                    {cls.description || "No description provided"}
                  </p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

 
      {showClassModal && (
        <CreateClassModal
          show={showClassModal}
          admin={admin}
          classData={selectedClass}
          closeModal={() => {
            setShowClassModal(false);
            setSelectedClass(null);
            fetchClasses();
          }}
        />
      )}

   
      <ToastContainer
        position="top-center"
        autoClose={2000}
        theme="colored"
      />
    </div>
  );
};

export default Classes;